import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SENTRY_DSN, UNKNOWN_TAG } from '../../constants';
var Sentry;
export var getEnvironment = function getEnvironment() {
  if (window.location.hostname.includes('localhost')) {
    return 'development';
  } else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) {
    return 'staging';
  } else {
    return 'production';
  }
};

// @ts-ignore - extra properties on window are not known
export var PRODUCT_BUILD = window.BUILD_KEY;
export var getSentryClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!Sentry) {
            Sentry = import( /* webpackChunkName: "@atlaskit-internal_@atlassian/dynamic-cards-search-common/sentry" */'@sentry/browser').then(function (SentryModule) {
              SentryModule.init({
                dsn: SENTRY_DSN,
                attachStacktrace: true,
                release: PRODUCT_BUILD || UNKNOWN_TAG,
                environment: getEnvironment()
              });
              return SentryModule;
            }).catch(function () {});
          }
          return _context.abrupt("return", Sentry);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSentryClient() {
    return _ref.apply(this, arguments);
  };
}();
export var logException = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error) {
    var _SentryClient;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return getSentryClient();
        case 3:
          _SentryClient = _context2.sent;
          if (_SentryClient) {
            _context2.next = 6;
            break;
          }
          return _context2.abrupt("return");
        case 6:
          _SentryClient.withScope(function (scope) {
            scope.setTag('product', 'hub');
            _SentryClient.captureException(error, scope);
          });
          _context2.next = 12;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          // When there was an error with Sentry, just output to console
          // eslint-disable-next-line no-console
          console.error(_context2.t0);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return function logException(_x) {
    return _ref2.apply(this, arguments);
  };
}();